import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
import { cacheResource, bindResource, addOnInvalidateHandler, invalidateResource } from "kea-resource";
const controller = rpcController("Ubicacion");
export const Ubicacion = cacheResource({
    ObtenerDTO: async (direccion: models.DireccionColonia): Promise<models.DireccionDTO> => await controller("ObtenerDTO", {}, direccion), 
});


// WEBPACK FOOTER //
// ./app/resources/items/ubicacion.ts